import Chip from '@mui/material/Chip'
import type { SxProps, Theme } from '@mui/material/styles'
import { MouseEvent, MouseEventHandler, ReactElement, ReactNode } from 'react'

export type FilterChipProps = {
    isSelected?: boolean
    label: ReactNode
    onClick?: (event: MouseEvent<HTMLElement>) => void
    avatar?: ReactElement
    sx?: SxProps<Theme>
}

function FilterChip({ isSelected, label, onClick, avatar, sx }: FilterChipProps): ReactElement {
    return (
        <Chip
            label={label}
            onClick={onClick}
            size="medium"
            avatar={avatar}
            sx={{
                p: 0.5,
                m: 0.5,
                ml: 0,
                '&, &:active, &:focus': {
                    color: isSelected ? 'common.white' : 'primary',
                    bgcolor: isSelected ? 'primary.main' : 'grey.300',
                },
                '&:hover': {
                    bgcolor: [undefined, isSelected ? 'primary.dark' : 'action.selected'],
                },
                ...sx,
            }}
        />
    )
}

export type FilterChipDeletableProps = {
    onClick: MouseEventHandler<HTMLButtonElement>
    label: string
    isSelected: boolean
}

export function FilterChipDeletable({ isSelected, label, onClick }: FilterChipDeletableProps): ReactElement | null {
    if (!isSelected) {
        return null
    }

    return <Chip label={label} onDelete={onClick} sx={{ p: 0.5, m: 0.5, ml: 0 }} />
}

export default FilterChip
